import React from "react"

const Container = ({ children }) => {
    return (
        <div className="shadow-sm p-3 space-y-2 border-b pb-4 my-5"> {children} </div>
    )
}

export default Container;